import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HttpclientService } from "../../../shared/services/httpclient.service";

@Injectable()
export class SemesterService {
	constructor(private httpclientService: HttpclientService) {}
	loadSemesterList(schoolID) {
		var postResult$ = new Subject();
		var url = "Report/SemesterGetList?SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
